import { getFieldsHavingWellDataApi, getMarkerNamesByFieldIdApi } from '@core/core/api'
import type { FieldId } from '@core/core/types'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const loadHotStorageFieldsHavingMarkers = createAsyncThunk(
  'hotStorage/loadFieldsHavingMarkers',
  () => getFieldsHavingWellDataApi('Markers'),
)

export const loadHotStorageMarkerNamesForField = createAsyncThunk(
  'hotStorage/loadMarkerNamesForField',
  async (fieldId: FieldId) => {
    const markerNames = await getMarkerNamesByFieldIdApi(fieldId)
    return { fieldId, markerNames }
  },
)
